export const smediasMutations = {
  setSmediasFormStatus(state, payload) {
    state.smediasFormStatus = payload;
  },
  setSmediasIsEdit(state, payload) {
    state.smediasIsEdit = payload
  },
  setSmediasSelectedForEdit(state, payload) {
    state.smediasSelectedForEdit = payload
  }, 
};